module.exports = __webpack_public_path__ + "static/media/playstation_color_png.19bbdd69.png";